import { SchemaData, UseUpdateProps } from "./types";
import { useCallback } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";
import { ApiAuthRequest } from "data/ApiForm";
import { removeNullValues } from "utils/removeNullValues";

export function useUpdate({ setState }: UseUpdateProps<SchemaData>) {
  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    setState((props) => ({
      ...props,
      loading: true,
      messageError: undefined,
      criticalError: undefined,
    }));

    return ApiAuthRequest<UpdateGql>({
      query: UPDATE_QUERY,
      variables: { id: state?.data?.id, sendResponsesTo: state?.data?.sendResponsesTo || [] },
    })
      .then((response) => {
        if (response?.data?.errors) {
          console.log(response?.data?.errors);
          throw response.data.errors[0];
        }
        if (!response?.data?.data?.["updateForm"]?.id) {
          throw new Error("Ops. Sem resposta!");
        }
        setState({
          data: {
            ...removeNullValues(response?.data?.data?.["updateForm"]),
          },
          loading: false,
        });
        return response;
      })
      .catch((error) => {
        console.log({ error });

        setState((prev) => ({
          ...prev,
          loading: false,
          criticalError: error?.response?.data?.errors?.[0] || error,
        }));

        throw error;
      });
  }, []);

  return {
    handleSave,
  };
}
